import { useSelector } from "react-redux";
import { getGridTableRowData } from "../../../selectors/ileggelseSystemloggerSelector";
import GridTable from "../../Common/GridTable";

export default function SystemloggContainer() {
  const gridTableRowData = useSelector(getGridTableRowData);
  return (
    <section>
      <div className="detalj-ileggelse-header-wrapper">
        <h2>Systemlogg</h2>
      </div>
      <div>
        <GridTable name="detaljSystemlogg" rows={gridTableRowData} />
      </div>
    </section>
  );
}
